import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { areaData } from '@/utils/city';
export default {
  name: 'areaSelect',
  props: {
    placeholder: {
      type: String,
      default: '请选择省市区'
    },
    defaultValue: {
      type: Array,
      default() {
        return [];
      }
    },
    index: {
      type: Number,
      default: -1
    },
    index2: {
      type: Number,
      default: -1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //地区数据
      areaData,
      //选择的数据
      selectedValues: []
    };
  },
  created() {
    if (this.defaultValue.length) {
      this.selectedValues = [...this.defaultValue];
    }
  },
  watch: {
    defaultValue(newValue) {
      if (newValue.length) {
        this.selectedValues = newValue;
      } else {
        this.selectedValues = [];
      }
    }
  },
  methods: {
    //选择好之后的回调
    onChange(value) {
      let arr = [];
      this.areaData.map(item => {
        if (item.code == value[0]) {
          arr.push(item.name);
          item.children.map(item2 => {
            if (item2.code == value[1]) {
              arr.push(item2.name);
              item2.children.map(item3 => {
                if (item3.code == value[2]) {
                  arr.push(item3.name);
                }
              });
            }
          });
        }
      });
      const valueName = arr.join(' ');
      this.$emit('change', value, valueName, this.index, this.index2);
    }
  }
};